<template>
  <div class="modal overflow-auto">
    <supporter-details v-if="step === 1" @nextStep="moveToNextStep()"></supporter-details>
    <donation-details
      v-if="step === 2"
      @previousStep="moveToPreviousStep()"
      @nextStep="moveToNextStep()"
      @moveToStep="moveToStep"
    ></donation-details>

    <!-- Use SMS payment -->
    <donation-payment-sms
      v-if="step === 3 && payload.paymentCaptureSystem === 'sms'"
      @nextStep="moveToNextStep()"
    ></donation-payment-sms>

    <!-- Use Credit Card or Direct Debit-->
    <donation-payment
      v-if="step === 3 && payload.paymentCaptureSystem === 'web'"
      @previousStep="moveToPreviousStep()"
      @nextStep="moveToNextStep()"
    ></donation-payment>
    <donation-receipt v-if="step === 4"></donation-receipt>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DonationDetails from './DonationDetails.vue';
import DonationPayment from './DonationPayment.vue';
import DonationPaymentSms from './DonationPaymentSms.vue';
import DonationReceipt from './DonationReceipt.vue';
import SupporterDetails from './SupporterDetails.vue';

export default {
  name: 'DonationModalMain',
  data() {
    return {
      step: 1,
      maxStep: 4,
    };
  },
  computed: {
    ...mapState({
      payload: state => state.donationModal.payload,
    }),
  },
  components: {
    SupporterDetails,
    DonationDetails,
    DonationPayment,
    DonationPaymentSms,
    DonationReceipt,
  },
  methods: {
    moveToNextStep() {
      if (this.step !== this.maxStep) {
        this.step += 1;
      }
    },
    moveToPreviousStep() {
      if (this.step !== 1) {
        this.step -= 1;
      }
    },
    moveToStep(step) {
      if (step < 1 || step > this.maxStep) {
        return;
      }
      
      this.step = step;
    },
  },
};
</script>

<style></style>
